export interface TextareaSelection {
  readonly start: number;
  readonly end: number;
}

export function shouldRestoreTextareaSelection(
  scheduledRevision: number,
  currentRevision: number,
): boolean {
  return scheduledRevision === currentRevision;
}

export function appendTranscriptAtSelection(
  value: string,
  selection: TextareaSelection,
  transcript: string,
): { readonly value: string; readonly selection: TextareaSelection } {
  const start = Math.max(0, Math.min(selection.start, value.length));
  const end = Math.max(start, Math.min(selection.end, value.length));
  const text = transcript.trim();
  if (text.length === 0) {
    return { value, selection: { start, end } };
  }
  const before = value.slice(0, start);
  const after = value.slice(end);
  const leadingSpace = before.length > 0 && !/\s$/.test(before) ? " " : "";
  const trailingSpace = after.length > 0 && !/^\s/.test(after) ? " " : "";
  return appendTextAtSelection(value, selection, `${leadingSpace}${text}${trailingSpace}`);
}

export function appendTextAtSelection(
  value: string,
  selection: TextareaSelection,
  suffix: string,
): { readonly value: string; readonly selection: TextareaSelection } {
  const start = Math.max(0, Math.min(selection.start, value.length));
  const end = Math.max(start, Math.min(selection.end, value.length));
  const nextValue = `${value.slice(0, start)}${suffix}${value.slice(end)}`;
  const caret = start + suffix.length;
  return { value: nextValue, selection: { start: caret, end: caret } };
}
